/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.editor-content {
  min-height: calc(var(--spacing, 0.25rem) * 60);
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  padding-top: calc(var(--spacing, 0.25rem) * 4);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-leading: 1.75rem;
  line-height: 1.75rem;
  text-wrap: pretty;
  word-break: break-all;
  caret-color: hsl(var(--primary));
  &:focus-visible {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  & p {
    margin-block: calc(var(--spacing, 0.25rem) * 4);
  }
  & h6 {
    font-size: 1rem;
  }
  & h5 {
    font-size: 1.15rem;
  }
  & h4 {
    font-size: 1.3rem;
  }
  & h3 {
    font-size: 1.45rem;
  }
  & h2 {
    font-size: 1.6rem;
  }
  & h1 {
    font-size: 1.75rem;
  }
  & h1, & h2, & h3, & h4, & h5, & h6 {
    margin-block: calc(var(--spacing, 0.25rem) * 6);
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 2px;
    border-color: hsl(var(--primary));
    padding-left: calc(var(--spacing, 0.25rem) * 4);
  }
  & strong {
    --tw-font-weight: 800;
    font-weight: 800;
  }
  & em {
    --tw-font-weight: 300;
    font-weight: 300;
    font-style: italic;
  }
  & a {
    color: hsl(var(--primary));
    text-decoration-line: underline;
    text-underline-offset: 4px;
  }
  & ol {
    list-style-type: decimal;
  }
  & ul {
    list-style-type: disc;
  }
  & ol, & ul {
    margin-left: calc(var(--spacing, 0.25rem) * 4);
    & *::marker {
      color: hsl(var(--primary));
    }
    &::marker {
      color: hsl(var(--primary));
    }
    & *::-webkit-details-marker {
      color: hsl(var(--primary));
    }
    &::-webkit-details-marker {
      color: hsl(var(--primary));
    }
  }
  & hr {
    margin-block: calc(var(--spacing, 0.25rem) * 6);
    border-color: hsl(var(--primary));
  }
  & blockquote {
    margin-bottom: 0px;
    border-top-right-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 2px;
    border-color: hsl(var(--primary));
    background-color: hsl(var(--primary-foreground));
    padding-inline: calc(var(--spacing, 0.25rem) * 4);
    padding-block: calc(var(--spacing, 0.25rem) * 2);
    & p {
      margin-block: calc(var(--spacing, 0.25rem) * 2);
    }
    & p:first-child {
      margin-top: 0px;
    }
    & p:last-child {
      margin-bottom: 0px;
    }
  }
  & pre {
    overflow-x: auto;
    border-radius: var(--radius);
    background-color: hsl(var(--primary-foreground));
    padding: calc(var(--spacing, 0.25rem) * 4);
    font-size: var(--text-xs, 0.75rem);
    line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  }
  & img {
    max-width: calc(var(--spacing, 0.25rem) * 60);
    min-width: calc(var(--spacing, 0.25rem) * 20);
    object-fit: contain;
  }
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-leading: initial;
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
